import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_SEARCH_CUSTOMER_TYPES } from 'constants/urls';

interface CustomerTypeFilters {
  SearchKeyword?: string;
  Page?: number;
  Take?: number;
}

const searchCustomerTypes = async (filters: CustomerTypeFilters = {}) => {
  const payload = {
    Id: 0,
    SearchKeyword: filters.SearchKeyword || '',
    Page: filters.Page || 1,
    Take: filters.Take || 2147483647,
  };

  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_SEARCH_CUSTOMER_TYPES}?payload=${JSON.stringify(payload)}`,
      { headers: { 'Content-Type': 'application/json;charset=UTF-8' }, data: null },
    );
    return data;
  } catch (error) {
    console.error('[searchCustomerTypes] Failed:', error);
    throw error;
  }
};

export default searchCustomerTypes;
